"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const useCreateQuery_1 = require("../hooks/useCreateQuery");
const CreateQueryDialog = ({ open, queryGroup, onCancel, onCreated }) => {
    const [formValues, setFormValues] = (0, react_1.useState)({});
    const { createdQuery, isCreating, error, createQuery } = (0, useCreateQuery_1.useCreateQuery)();
    const onCreatedRef = (0, react_1.useRef)(onCreated);
    (0, react_1.useEffect)(() => {
        var _a;
        if (createdQuery) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdQuery);
        }
    }, [createdQuery]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Create Entity"),
        react_1.default.createElement("form", null,
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(core_1.TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Query Name', value: formValues.name || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) }))),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
                react_1.default.createElement(core_1.Button, { variant: 'contained', type: 'submit', disabled: !formValues.name, endIcon: isCreating && react_1.default.createElement(core_1.CircularProgress, { size: 20 }), onClick: () => {
                        console.log('onSubmit', formValues);
                        if (formValues.name) {
                            createQuery(Object.assign(Object.assign({}, formValues), { queryGroupId: queryGroup.id }));
                        }
                    } }, "Submit"))),
        error && (react_1.default.createElement(core_ui_1.AppSnackbar, { open: true, severity: 'error' }, error.message || 'An error occurred'))));
};
exports.default = CreateQueryDialog;
//# sourceMappingURL=CreateQueryDialog.js.map